/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Hidden_EmptyInputs */



/**
* | output |
* | --- |
* | "You have not hidden anyone yet." |
*
* @param {Team_Hidden_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_hidden_empty = /** @type {((inputs?: Team_Hidden_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Hidden_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je hebt nog niemand verborgen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez encore masqué personne.")
	return /** @type {LocalizedString} */ ("You have not hidden anyone yet.")
});